import React, {
  Fragment,
  useMemo,
  useState,
} from 'react';

import { get } from 'lodash';
import {
  usePermissions,
  useRedirect,
  useTranslate,
} from 'react-admin';

import {
  Box,
  Button,
  ButtonGroup,
  Link,
  makeStyles,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import DescriptionIcon from '@material-ui/icons/Description';
import GetAppIcon from '@material-ui/icons/GetApp';
import PublishIcon from '@material-ui/icons/Publish';

import EditButton from '../buttons/EditButton';
import InvoiceDialog from '../dialogs/InvoiceDialog';

const useStyles = makeStyles((theme) => ({
	button: {
		// marginBottom: theme.spacing(0.5),
	},
	box: {
		display: "flex",
		flexDirection: "column",
		maxWidth: 450,
	},
	wtr: {
		whiteSpace: "break-spaces",
		paddingTop: theme.spacing(1),
		// paddingBottom: theme.spacing(2),
		display: "flex",
		fontSize: 12,
		// alignItems: "center",
	},
}));

const InvoiceField = ({ record, sortable, range, ...props }) => {
	const classes = useStyles();
	const [viewInvoice, setViewInvoice] = useState(false);
	const translate = useTranslate();
	const invoiceName = get(record, "invoice_name");
	const canRequestUserWtr = get(record, "can_request_user_wtr");
	const userWtrRequested = get(record, "user_wtr_requested");
	const wtr = get(record, "withholding_tax_return");
	const year = get(record, "year");
	const month = get(record, "month");
	const isLastRange = `${year}/${month}` === range;
	const sm = useMediaQuery((theme) => theme.breakpoints.down("sm"));
	const theme = useTheme();
	const isTotal = get(record, "is_total");
	const { permissions } = usePermissions();
	const isAdmin = useMemo(
		() => permissions && permissions("admin"),
		[permissions]
	);
	const redirect = useRedirect();
	if (isTotal) {
		return null;
	}
	const handleDownload = () => {
		const url = `${get(record, "invoice.path")}?token=${localStorage.getItem(
			"token"
		)}&refresh=${Math.random()}`;
		window.open(url);
	};
	return (
		<Box className={classes.box}>
			<ButtonGroup orientation="vertical" fullWidth>
				<EditButton
					disableElevation
					className={classes.button}
					isAdmin={permissions && permissions("admin")}
					icon={<PublishIcon />}
					record={record}
					size="small"
					{...props}
				/>
				<Button
					disableElevation
					className={classes.button}
					variant="contained"
					onClick={() => setViewInvoice(true)}
					disabled={viewInvoice}
					startIcon={<DescriptionIcon />}
					style={!sm ? { marginRight: theme.spacing(1) } : {}}
					size="small"
					color="primary"
				>
					{translate("resources.user-payments.buttons.invoice")}
				</Button>
				{invoiceName !== null && (
					<Button
						disableElevation
						className={classes.button}
						variant="contained"
						color="secondary"
						onClick={handleDownload}
						size="small"
						startIcon={<GetAppIcon />}
					>
						{translate("resources.user-payments.buttons.download")}
					</Button>
				)}
				{viewInvoice && (
					<InvoiceDialog
						userPayment={record}
						onClose={() => setViewInvoice(false)}
					/>
				)}
			</ButtonGroup>
			{!isAdmin && (
				<Fragment>
					{((isLastRange && canRequestUserWtr) ||
						(userWtrRequested && wtr === 1)) && (
						<Typography>
							<Link
								href="#"
								onClick={(e) => {
									e.preventDefault();
									redirect(
										`/user-wtrs?filter=${JSON.stringify({
											request: 1,
											year,
											target_year: year,
										})}`
									);
								}}
								className={classes.wtr}
							>
								<Fragment>
									{userWtrRequested
										? translate(
												`resources.users.fields.profile.withholding_tax_return_requested`,
												{
													year,
												}
										  )
										: translate(
												`resources.users.fields.profile.withholding_tax_return`,
												{
													year,
												}
										  )}
								</Fragment>
							</Link>
						</Typography>
					)}
				</Fragment>
			)}
		</Box>
	);
};

export default InvoiceField;
